import { LinkTargetType } from "views/services/playground";
import { TProductElement } from "../../views/services/product";
import { CommonRuntime } from "utils/runtime";

export function runInBrowser() {
	return typeof window !== "undefined";
}
/**
 * 某一模块是否在可视窗口内
 */
export const isInWindowView = (ele: HTMLElement, fixedTop: number = 0): boolean => {
	if (!runInBrowser()) {
		return false;
	}
	if (ele && ele.getBoundingClientRect()) {
		const { top, bottom } = ele.getBoundingClientRect();
		const windowHeight = window?.innerHeight;
		if (bottom <= fixedTop) {
			return false;
		}
		if (top >= windowHeight - fixedTop) {
			return false;
		}
		return true;
	}
	return false;
};

/**
 * a 跳转方式
 * App 内利用特性href
 * web 上利用特性onClick
 */
interface TransformAParamProps {
	isInApp: boolean;
	aTarget: LinkTargetType;
	link: string;
	onClick?: () => void;
	isProductWrap?: boolean;
	runtime?: CommonRuntime;
}
interface TransformAParamResp {
	href?: string;
	target?: string;
	"data-href"?: string;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}
// isProductWrap修复判断M端在APP内，click事件ctr未上报
export const transformAParam = ({
	isInApp = true,
	aTarget = LinkTargetType.Blank,
	link = "",
	onClick,
	isProductWrap = false,
	runtime,
}: TransformAParamProps): TransformAParamResp => {
	if (!link) {
		return {};
	}

	if (link.startsWith("#")) {
		return {
			href: link,
			target: LinkTargetType.Self,
		};
	}

	if ((isInApp || aTarget === LinkTargetType.Self) && !isProductWrap) {
		return {
			href: link,
			target: aTarget,
		};
	}
	return {
		onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			e.preventDefault();
			e.stopPropagation();
			onClick && onClick();
			if (isInApp && runtime && isProductWrap) {
				const { cookies } = runtime;
				if (cookies && cookies["ci-client"].match(/iphone/i)) {
					window.location.href = link;
					return;
				}
			}
			window.open(link);
		},
		"data-href": link,
	};
};

export const returnProductIndex = (gpid: string, product: TProductElement[]): number => {
	let index = -1;
	if (gpid && product) {
		const ind = product.findIndex((item) => item.gpid === gpid);
		if (ind > -1) {
			index = ind + 1;
		}
	}
	return index;
};
